import { createFileRoute } from '@tanstack/react-router'
import ComingSoon from "@/views/coming_soon";

export const Route = createFileRoute('/_authenticated/coming_soon')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ComingSoon/>
}
